<div class="container-fluid">
  <h5 class="mb-3">Success</h5>
  <div class="card p-5">
    <div class="text-center mb-5">
      <h5>
        <!-- Congrats! You helped {{ (runningPayroll$ | async)?.employeeCount }} people and their
        families get paid! -->
        Payroll for the {{ (runningPayroll$ | async)?.payPeriodEnd | date: 'MMM yyyy' }} has been
        Confirmed, Please mark it as paid once paid successfully.
      </h5>
      <p>
        your payroll is confirmed. You may find it in
        <a [routerLink]="[eps.hrm.managePayrollPath]">Pay-runs</a>
      </p>
    </div>

    <div class="row">
      <p class="col-lg-6 text-lg-end">Total Employer Cost:</p>

      <p class="col-lg-6 fw-bold">
        {{
          ((runningPayroll$ | async)?.totalAmount || 0) +
            ((runningPayroll$ | async)?.totalEsiEmployer || 0)
            | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
        }}
      </p>
    </div>

    <div class="row">
      <p class="col-lg-6 text-lg-end">Total ESI Employer:</p>
      <p class="col-lg-6 fw-bold">
        {{
          (runningPayroll$ | async)?.totalEsiEmployer
            | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
        }}
      </p>
    </div>

    <div class="row">
      <p class="col-lg-6 text-lg-end">Total Gross:</p>
      <p class="col-lg-6 fw-bold">
        {{
          (runningPayroll$ | async)?.totalAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
        }}
      </p>
    </div>

    <div class="row">
      <p class="col-lg-6 text-lg-end">TDS after cess:</p>
      <p class="col-lg-6 fw-bold">
        {{
          (runningPayroll$ | async)?.totalTdsAfterCess
            | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
        }}
      </p>
    </div>
    <div class="row">
      <p class="col-lg-6 text-lg-end">Total ESI Employee:</p>
      <p class="col-lg-6 fw-bold">
        {{
          (runningPayroll$ | async)?.totalEsiEmployee
            | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
        }}
      </p>
    </div>

    <div class="row">
      <p class="col-lg-6 text-lg-end">Net Salary:</p>
      <p class="col-lg-6 fw-bold">
        {{ (runningPayroll$ | async)?.netAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
      </p>
    </div>
  </div>
  <!-- Confirm Payroll Button Bottom -->
  <div class="text-center">
    <!--<button class="btn btn-primary ms-2" (click)="changeScreen(true)">Confirm Payroll</button>-->
  </div>
</div>
